import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { SvgIconComponent } from '@ngneat/svg-icon'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-refresh-website-dialog',
  templateUrl: './refresh-website-dialog.component.html',
  styleUrls: ['./refresh-website-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent]
})
export class RefreshWebsiteDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<RefreshWebsiteDialogComponent>) {}

  ngOnInit(): void {
    this.dialogRef.disableClose = true
  }

  refresh() {
    document.location.href = '/'
  }
}
